import React from "react";
import PropTypes from "prop-types";

function Label({ title = "", subTitle = "", customStyleClassName = "" }) {
  return (
    <div
      className={
        customStyleClassName
          ? customStyleClassName
          : "grid gap-[10px] min-w-[250px] sm-max:w-full"
      }
    >
      <div className="text-[#51525C] font-medium text-[16px]">{title}</div>

      <div className="text-[#1D1B22] font-semibold text-[16px]">
        {subTitle || "-"}
      </div>
    </div>
  );
}

Label.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string || PropTypes.element,
  customStyleClassName: PropTypes.string,
};

export default Label;
